<template>
  <div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">Cartographies collectives</p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
        >
          Retrouvez ici différentes données sur vos carnets de parcours.<br />
          Vous pouvez enregistrer manuellement chaque cartographie et faire des
          comparaisons par date
        </p>
      </div>
      <illustration
        name="cartographie"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>

    <div v-if="allowed">
      <!-- BEGIN List Buttons action -->
      <div class="flex mb-5 lg:mt-10 lg:mb-10 items-center">
        <action-button
          v-if="$can('cartography_collective_export')"
          class="mr-10 tour_carto_print"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-indigo-300"
          bg-color-square="bg-indigo-200"
          icon-color="text-indigo-600"
          libelle="Imprimer"
          icon="printer"
        />
      </div>
      <!-- END List Buttons action -->

      <!-- Contenu -->
      <div class="flex flex-col">
        <div
          class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pt-15 px-10 xl:pt-0 xl:px-15 pb-10 min-h-halfscreen overflow-x-auto"
        >
          <router-view />
        </div>
      </div>
      <!-- Fin Contenu -->
    </div>

    <page-not-allowed v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionButton from '../../components/ActionButton';
import Illustration from '../../components/Illustration';

import PageNotAllowed from './../../components/PageNotAllowed';

export default {
  name: 'CartoCollectiveLayout',

  components: {
    ActionButton,
    Illustration,
    PageNotAllowed,
  },

  data() {
    return {
      //
    };
  },

  methods: {
    //
  },

  computed: {
    ...mapGetters({
      allowed: 'app/allowed',
    }),
  },
};
</script>
